import { useAppContext } from "../../app-context/use-app-context"
import { useGetChatsQuery } from "../api"

// Matches the backend floor: below this a search matches too much to be worth a round trip.
const MIN_SEARCH_LENGTH = 2

export const useChatRouteData = (search = "") => {
  const {
    appContext: { mainContext, subContext },
  } = useAppContext()

  const context = mainContext
  const memberId = subContext?.type === "member" ? subContext?.id : undefined
  const workspaceId = subContext?.type === "workspace" ? subContext?.id : undefined
  const orgId = context?.id

  const { data: chats = [], ...chatRequest } = useGetChatsQuery(
    { orgId: orgId!, member: memberId, workspace: workspaceId },
    {
      skip: !orgId,
      // This poll is just a safety net for a missed/dropped event, so it can be slow.
      pollingInterval: 5 * 60_000,
      refetchOnMountOrArgChange: true,
    }
  )

  const trimmed = search.trim()
  const searching = trimmed.length >= MIN_SEARCH_LENGTH

  // A second subscription: narrowing the one list would unmount the open chat and its draft.
  const { data: searchResults = [] } = useGetChatsQuery(
    { orgId: orgId!, member: memberId, workspace: workspaceId, search: trimmed },
    { skip: !orgId || !searching }
  )

  return {
    context,
    chats,
    sidebarChats: searching ? searchResults : chats,
    ...chatRequest,
  }
}
